import script from "./DoctorInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./DoctorInfo.vue?vue&type=script&lang=ts&setup=true"

import "./DoctorInfo.vue?vue&type=style&index=0&id=1b265848&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b265848"]])

export default __exports__